module.exports = __webpack_public_path__ + "static/media/SolidDownArrow.d80c4c8c.svg";